import { render, staticRenderFns } from "./Monitoreo.vue?vue&type=template&id=033d730e"
import script from "./Monitoreo.vue?vue&type=script&lang=js"
export * from "./Monitoreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports